export function injectAccessibility () {
  window.interdeal = {
    get sitekey () { return '75f564ffd9117b0285aca702fe31ffc4' },
    get domains () { return { js: 'https://cdn.nagich.com/', acc: 'https://access.nagich.com/' } },
    Position: 'left',
    Menulang: 'EN',
    draggable: true,
    btnStyle: {
      vPosition: ['80%', '80%'],
      margin: ['0', '0'],
      scale: ['0.5', '0.5'],
      color: { main: '#262624', second: '#ffffff' },
      icon: { outline: false, outlineColor: '#ffffff', type: 11, shape: 'circle' }
    }
  }

  const old = document.querySelector('script[data-equalweb="true"]')
  if (old) old.remove()

  const s = document.createElement('script')
  s.src = window.interdeal.domains.js + 'core/5.1.2/accessibility.js'
  s.defer = true
  s.integrity = 'sha512-PUyQFF3HFjRiVfjOiFFu+RTc0nGmLV5FN3CVw8zWFK6pVbWPAEKy9X2bTUn10GNu1EbxN56MuWu0P8ZHC6xv3Q=='
  s.crossOrigin = 'anonymous'
  s.setAttribute('data-equalweb', 'true')
  document.body.appendChild(s)
}
